import React from 'react';

export function MetricSkeleton() {
  return (
    <div className="flex flex-col gap-2 grow">
      <div className="h-[22px] w-28 animate-pulse rounded bg-gray-200" />
      <div className="h-[26px] w-16 animate-pulse rounded bg-gray-200" />
      <div className="h-[20px] w-40 animate-pulse rounded bg-gray-200" />
    </div>
  );
}
